import React, { useState } from 'react';
import {
   space,
   color,
   fontSize,
   breakpoint
} from "@core-ds/primitives";
import styled from 'styled-components';
import constants from '../../Shared/core-components/constants';
import GuideHighlight from "./guide_highlight"
import GuideLink from "./guide_link"
import { Guide, FeaturedGuidesProps } from "./featured_guides_types"
import MediaQuery from 'react-responsive'

const {
   typography,
} = constants;

const MOBILE = `@media only screen and (max-width: ${breakpoint.sm})`;
const TABLET = `@media only screen and (max-width: ${breakpoint.md})`;

const Title = styled.h3`
   ${typography.title.default}
   color: black;
   font-size: ${fontSize[3]};
   margin-bottom: ${space[4]};
   text-transform: uppercase;

   ${MOBILE} {
      text-align: center;
   }
`
const DesktopContainer = styled.div`
   justify-content: space-between;
   display: flex;
`;

const MobileContainer = styled.div`
   overflow-x: auto;
   display: block;
`;

const HighlightScroll = styled.div`
   white-space: nowrap;

   ${MOBILE} {
      padding-left: ${space[7]};
   }
`;

const DesktopHighlight = styled(GuideHighlight)`
   flex: 7;
   margin-right: ${space[7]};

   ${TABLET} {
      flex: 5;
      display: block;
   }
`;


const MobileHighlight = styled(GuideHighlight)`
   display: inline-block;
   white-space: normal;
   vertical-align: top;
   width: calc(85vw - ${space[7]}*3);
   margin-right: ${space[7]};
`;

const Links = styled.div`
   flex: 4;
   display: block;
`;

const FeaturedGuideBox = styled.div`
   padding: ${space[7]};
   background-color: ${color.gray1};
   ${typography.paragraph}
   text-align: left;

   ${MOBILE} {
      padding: ${space[7]} 0;
   }
`;

function FeaturedGuides(props: FeaturedGuidesProps) {
   const [activeLink, setActiveLink] = useState(0);

   const guides: Array<Guide> = props.guides;

   if (guides.length == 0) {
       return null;
   }

   return (
      <FeaturedGuideBox>
         <Title>{_js("Featured Fixes")}</Title>
         <MediaQuery minWidth={breakpoint.sm} >{(matches) => matches ?
            <DesktopContainer>
               <DesktopHighlight guide={guides[activeLink]}/>
               <Links>
                  {guides.map((guide: Guide, index: number) => (
                     <GuideLink
                        key={guide.url}
                        guide={guide}
                        active={index == activeLink}
                        onClick={() => setActiveLink(index)}/>
                  ))}
               </Links>
            </DesktopContainer>
               :
            <MobileContainer>
               <HighlightScroll>
                  {guides.map((guide: Guide) => (
                     <MobileHighlight
                        guide={guide}
                        key={guide.url}
                     />
                  ))}
               </HighlightScroll>
            </MobileContainer>
         }</MediaQuery>
      </FeaturedGuideBox>
   )
}

export default FeaturedGuides
